import { Component, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'app-homepage',
  standalone: false,
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomepageComponent { }
